import React from "react";
import { createRoot } from "react-dom/client";
import { SiteTheme } from "../../types/types";
import RecipeSearch from "./RecipeSearch";

const RecipeSearchContainer = () => {

    const container = document.querySelector(
        "#recipe-search",
    ) as HTMLElement;
    const siteTheme = document
        .querySelector("body")
        ?.getAttribute("data-site") as SiteTheme;

    if (container) {
        createRoot(container).render(
            <RecipeSearch
                siteTheme={siteTheme}
                searchPageUrl="/recept/"
            />,
        );
    }
};

export default RecipeSearchContainer;
